import merge from 'lodash/merge'
import {
	SET_ACTIVE_ROOM,
	RESET_ACTIVE_ROOM
} from '../actions/setActiveRoomActions'
import { REMOVE_ACTIVE_ROOM } from '../actions/removeActiveRoomActions'

const initialState = {
}

export default function activeRoomReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_ROOM:
			// Select activeRoom manually
			return merge({}, state, action.payload)

		case REMOVE_ACTIVE_ROOM:
			// Remove activeRoom by ID
			return (state, action.payload)

		case RESET_ACTIVE_ROOM:
			return (state, {})

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeRoomReducers.js